module.exports = __webpack_public_path__ + "media/images/twitter-white-53dad9bd.png";